export let EntryType;

(function (EntryType) {
  EntryType[EntryType["Default"] = 10] = "Default";
  EntryType[EntryType["Intro"] = 20] = "Intro";
  EntryType[EntryType["Seller"] = 30] = "Seller";
  EntryType[EntryType["NewItem"] = 60] = "NewItem";
  EntryType[EntryType["IdentityDocument"] = 70] = "IdentityDocument";
})(EntryType || (EntryType = {}));